import _intersection from 'lodash/intersection';
import _isEqual from 'lodash/isEqual';
import _uniqWith from 'lodash/uniqWith';

import { DEPARTURE_PORT, DESTINATION, NIGHTS, PORT, PROMO, SHIP, START_DATE } from '../constants';

const flatSearchFilters = (search) => {
	return search
		?.split('|')
		.filter(Boolean)
		.map((item) => item.split(':')?.[1]?.split(','))
		.flatMap((item) => item);
};

const getUniqueDestinationKeysApplied = (uniqueDestinationFinded) => {
	const destinations =
		uniqueDestinationFinded?.['destinations']?.map((item) => {
			return {
				[uniqueDestinationFinded.code]: item,
			};
		}) || [];

	return destinations;
};

const getDataDestination = (data) => {
	const { item, filters, paramsValue, selected, isPromo } = data;

	return {
		...item,
		destinations: filters,
		paramsAnalytics: paramsValue,
		selected,
		isPromo,
	};
};

const loadUniqueDestinations = (listUniqueDestinations, filtersSearchToCheck, others, promotionSelected) => {
	const uniqueDestinations = listUniqueDestinations.map((item) => {
		const criteria = item?.criteria;
		if (criteria?.[PROMO]) {
			if (promotionSelected) {
				const query = criteria;
				const newParams = { ...query };
				delete newParams[START_DATE];
				delete newParams[SHIP];
				delete newParams[DESTINATION];
				delete newParams[DEPARTURE_PORT];
				delete newParams[PORT];
				delete newParams[NIGHTS];

				const params = { ...newParams };
				const paramsValue = Object.keys(params).map((key) => `${key}=${params[key]}`);
				const filters = Object.keys(params || {});
				const selected = criteria?.promo.includes(promotionSelected);

				return getDataDestination({ item, filters, paramsValue: paramsValue.join('&'), selected, isPromo: true });
			} else {
				return getDataDestination({ item, filters: {}, paramsValue: '', selected: false, isPromo: true });
			}
		} else {
			const valueToCheck = item?.code;
			const params = item?.urlParams?.map((param) => {
				return `${param['key']}:${param['value']}`;
			});
			const filters = Object.keys(getObjectFromQuery(valueToCheck, '|', ':') || {});
			const filtersUniqueDestinationToCheck = valueToCheck.split();
			const selected = _isEqual(_intersection(filtersUniqueDestinationToCheck, filtersSearchToCheck), filtersUniqueDestinationToCheck);

			return getDataDestination({ item, filters, paramsValue: params.join('&'), selected, isPromo: false });
		}
	});

	return uniqueDestinations;
};

export const valueParamsToObject = (value) => {
	return JSON.parse(
		'{"' + decodeURI(value).replace(/"/g, '\\"').replace(/&/g, '","').replace(/\|/g, '","').replace(/:/g, '":"').replace(/=/g, '":"') + '"}',
	);
};

export const getObjectFromQuery = (search, keyJoin, keyEqual) => {
	if (typeof search === 'string') {
		return Object.fromEntries(
			search
				.split(keyJoin)
				.filter(Boolean)
				.map((item) => item.split(keyEqual)),
		);
	} else {
		return {};
	}
};

export const getQueryFromObject = (params, keyJoin, keyEqual) => {
	return Object.entries(params)
		.filter(([, value]) => !!value)
		.map(([key, value]) => `${key}${keyEqual}${value}`)
		.join(keyJoin);
};

export const validateIsUniqueDestination = (uniqueDestinationsAvailable, filterName) => {
	return uniqueDestinationsAvailable.includes(filterName);
};

export const getUniqueDestinationAndParamsUtil = (uniqueDestination, prevUniqueDestinations) => {
	const prevUniqueFilters = (prevUniqueDestinations || []).filter((item) => item[uniqueDestination?.filterName]);
	const uniqueDestinations = [..._uniqWith([...prevUniqueFilters, ...getUniqueDestinationKeysApplied(uniqueDestination)], _isEqual)];
	const additionalParamsApplied = uniqueDestination?.paramValue;
	return {
		uniqueDestinations,
		additionalParamsApplied,
	};
};

export const validateUniqueAppliedUtil = (filters, allFilters, others) => {
	const othersParams = [
		Object.keys(others)
			.map((key) => `${key}=${others[key]}`)
			.join('&'),
	].filter(Boolean);
	const filtersUniqueDestinationToCheck = flatSearchFilters(filters);

	const filtersApplied = Object.values(allFilters || {})
		.flatMap((item) => item)
		.filter(Boolean);
	const selected =
		_isEqual(_intersection(filtersUniqueDestinationToCheck, filtersApplied), filtersUniqueDestinationToCheck) &&
		_isEqual(_intersection(othersParams, filtersApplied), othersParams);

	return selected;
};

export const updatedUniqueDestinationsUtil = (data) => {
	const { customFiltersOptions: listUniqueDestinations, search, others, promotionApplied, additionalParamsApplied } = data;
	let uniqueDestinationFinded;

	if (promotionApplied) {
		uniqueDestinationFinded = loadUniqueDestinations(listUniqueDestinations, null, others, promotionApplied).filter((item) => item.selected)?.[0];
	} else {
		const filtersSearchToCheck = flatSearchFilters(search);
		uniqueDestinationFinded = listUniqueDestinations?.length
			? loadUniqueDestinations(listUniqueDestinations, filtersSearchToCheck, others).filter((item) => item?.selected)?.[0]
			: [];
	}
	const destinations = getUniqueDestinationKeysApplied(uniqueDestinationFinded);
	let paramsAnalytics = additionalParamsApplied || null;

	if (Object.keys(uniqueDestinationFinded || {})?.length) {
		paramsAnalytics = uniqueDestinationFinded?.['paramsAnalytics'] || null;
	}

	return {
		destinations,
		paramsAnalytics,
	};
};

export const getUniqueDestinationsStateUtil = (data) => {
	const { customFiltersOptions: listUniqueDestinations = [], container, selectingFilters, others, promotion: promotionSelected = null } = data;

	const filters =
		listUniqueDestinations.filter((filter) => {
			if (container) return filter?.containers?.includes(container);
			else return filter;
		}) || [];

	const filtersSearchToCheck = flatSearchFilters(selectingFilters);
	const specialFilters = loadUniqueDestinations(filters, filtersSearchToCheck, others, promotionSelected);

	return specialFilters;
};
